<template>
    <div class="header">
        <el-row>
            <el-col :span="8">
                <img class="logo" src="../../assets/logo.png">
            </el-col>
            <el-col :span="2" :offset="14">
                <el-dropdown>
                    <span class="el-dropdown-link">
                        <img class="head" :src="userInfo.img" align="absmiddle" >&nbsp; <strong>{{userInfo.name}}</strong>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>修改密码</el-dropdown-item>
                        <el-dropdown-item>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </el-col>
        </el-row>

    </div>

</template>

<script>
export default {
  name: "LayoutHeader",
  created:function(){
      if(localStorage.getItem('userInfo')){
        this.userInfo=JSON.parse(localStorage.getItem('userInfo'));
      }else{
          this.$router.push({ name: "Login" });
      }
  },
  data() {
    return {
        userInfo:{
            name:'',
            img:'',
        }
    };
  },
  methods: {
    handleSelect() {}
  }
};
</script>

<style scoped>
.head {
  width: 40px;
  height: 40px;
  border-radius: 40px;
}
.logo{
    width: 200px;
}
.el-row{
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/LayoutHeader.vue